import Hero from "@/components/site/Hero";
import Philosophy from "@/components/site/Philosophy";
import About from "@/components/site/About";
import ServicesPreview from "@/components/site/ServicesPreview";
import UpcomingClasses from "@/components/site/UpcomingClasses";
import AstrologySection from "@/components/site/AstrologySection";
import CtaBanner from "@/components/site/CtaBanner";

const Home = () => {
  return (
    <div data-testid="page-home">
      <Hero />
      <About />
      <ServicesPreview />
      <UpcomingClasses />
      <Philosophy />
      <AstrologySection />
      <CtaBanner />
    </div>
  );
};

export default Home;
